import { DateTime } from 'luxon';
import { makeAutoObservable } from 'mobx';
import { ExchangeRatesResponse } from '../../api/ExchangeRatesApi';
import { ExchangeRate } from './ExchangeRate';

export class DailyExchangeRates {
  rates: Map<string, Map<string, ExchangeRate>>;
  date: DateTime;

  static fromApi(apiData: ExchangeRatesResponse): DailyExchangeRates {
    const exchangeRate = new DailyExchangeRates();
    exchangeRate.rates = apiData
      ? new Map(
          Object.keys(apiData.rates).map(curr1 => [
            curr1,
            new Map(
              Object.keys(apiData.rates[curr1]).map(curr2 => [
                curr2,
                ExchangeRate.fromApi(apiData.rates[curr1][curr2]),
              ])
            ),
          ])
        )
      : new Map();
    exchangeRate.date = apiData ? DateTime.fromISO(apiData.date) : null;
    return exchangeRate;
  }
}

export class ExchangeRates {
  rates: Map<string, DailyExchangeRates> = new Map();

  constructor() {
    makeAutoObservable(this);
  }

  static fromApi(apiData: ExchangeRatesResponse[]) {
    const fxRates = new ExchangeRates();

    apiData.forEach(rate => {
      fxRates.rates.set(rate.date, DailyExchangeRates.fromApi(rate));
    });

    return fxRates;
  }

  atDate = (date: DateTime): DailyExchangeRates => {
    const dateString = date.toISODate();

    if (this.rates.has(dateString)) {
      return this.rates.get(dateString);
    }

    return null;
  };
}
